export enum LicenseProfileTab {
  Overview,
  Subscription,
  Security,
  Settings,
  Integrations,
  SSO
}
